defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/FrontPage',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'Common/Framework/EventHandling/Scripts/CrossWindowEvents',
    'DanskeSpil/Domain/Authentification/Scripts/LoginCache',
    'DanskeSpil/Domain/Authentification/Scripts/LoginController',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Api',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PromotionSpots'
  ],
  function (Component, CrossWindowEvents, LoginCache, LoginController, PlayTogetherDictionary, PlayTogetherApi, Loader, PromotionSpots) {

    // Component:
    Component('frontpage', [PlayTogetherDictionary], function (m, route, settings) {

      // Components:
      var root = {
        controller: function () {
          this.dictionary = PlayTogetherDictionary.get.bind({ prefix: 'FrontPage/' });
          this.d = this.dictionary;
          this.isLoading = m.prop(true);
          this.error = m.prop(null);
          this.createClubLink = m.prop(settings.createClubLink || null);
          this.createAccountLink = m.prop(settings.createAccountLink || null);
          this.viewClubsLink = m.prop(settings.viewClubsLink || null);
          this.introImage = m.prop(settings.introImage || null);
          this.introVimeoVideoId = m.prop(settings.introVimeoVideoId || null);
          this.onboardingFlowOne = m.prop({
            slides: settings.onboardingFlowOne || [],
            title: this.d('OnboardingTitle')
          });
          this.onboardingFlowTwo = m.prop({
            slides: settings.onboardingFlowTwo || [],
            title: this.d('OnboardingTitleTwo')
          });
          this.promotionSpots = settings.promotionSpots;
          this.userIsLoggedIn = m.prop(LoginCache.isLoggedIn());
          this.userHasClubs = m.prop(false);

          this.openLogin = function () {
            LoginController.openLogin();
          };

          CrossWindowEvents.subscribe('ds.event.getUserDataFromSitecore', function () {
            this.userIsLoggedIn(LoginCache.isLoggedIn());
            m.redraw();
          }.bind(this));

          if (this.userIsLoggedIn()) {
            PlayTogetherApi.getAllClubs({
              includePlayers: false,
              includeActiveGroupPlays: true
            }).then(function (response) {
              if (response.groups.length) {
                this.userHasClubs(true);
              }
              this.isLoading(false);
              m.redraw();
            }.bind(this), function (response) {
              this.error(response);
              this.isLoading(false);
              m.redraw();
            }.bind(this));
          } else {
            this.isLoading(false);
          }

          this.video = function (vimeoVideoId) {
            return m('.video-wrapper', [
              m('iframe.video', {
                class: 'column-image',
                src: 'https://player.vimeo.com/video/' + vimeoVideoId + '?title=0&byline=0&portrait=0&fs=false',
                frameborder: '0',
                allowfullscreen: '',
                webkitallowfullscreen: '',
                mozallowfullscreen: ''
              })
            ]);
          };
        },

        view: function (controller) {
          // Loading:
          if (controller.isLoading()) {
            return Loader(controller);
          }

          if (controller.error()) {
            return m('div', { class: 'play-together-section-wrapper' }, [
              m('div', { class: 'play-together-section-inner-wrapper' }, controller.error())
            ]);
          }

          return [
            m('.play-together-section-wrapper', [
              m('.play-together-section-inner-wrapper', [
                m('.play-together-front-page-header-section-wrapper', [
                  m('.play-together-front-page-header-column-wrapper', [
                    m('h1', { class: 'front-page-headline-wrapper' }, [
                      m('span', { class: 'headline-text' }, controller.d('PageTitle'))
                    ]),
                    m('h2', {
                      class: 'front-page-subheadline-wrapper'
                    }, controller.userIsLoggedIn() && controller.userHasClubs() ? controller.d('PageDescription') : controller.d('PageDescriptionNoClubs')),
                    m('div', { class: 'front-page-small-inner-wrapper' }, [
                      m('.play-together-section-buttons-wrapper', [
                        function () {
                          if (controller.userIsLoggedIn() && controller.userHasClubs()) {
                            return m('div', [
                              m('a', {
                                href: controller.viewClubsLink().Url,
                                title: controller.viewClubsLink().Title,
                                class: 'play-together-button yellow'
                              }, controller.viewClubsLink().Text),
                              m('a', {
                                href: controller.createClubLink().Url,
                                title: controller.createClubLink().Title,
                                class: 'play-together-button green'
                              }, controller.createClubLink().Text)
                            ]);
                          } else if (controller.userIsLoggedIn()) {
                            return m('a', {
                              href: controller.createClubLink().Url,
                              title: controller.createClubLink().Title,
                              class: 'play-together-button yellow'
                            }, controller.createClubLink().Text);
                          } else {
                            return m('button', {
                              class: 'play-together-button yellow',
                              type: 'button',
                              onclick: controller.openLogin
                            }, controller.d('LoginButton'));
                          }
                        }()
                      ]),
                      controller.introVimeoVideoId() ?
                        m('.play-together-front-page-header__video.desktop-hide.video-wrapper', [
                          m('iframe.video', {
                            src: 'https://player.vimeo.com/video/' + controller.introVimeoVideoId() + '?title=0&byline=0&portrait=0&fs=false',
                            frameborder: '0',
                            allowfullscreen: '',
                            webkitallowfullscreen: '',
                            mozallowfullscreen: ''
                          })
                        ]) : null,
                      m('div', controller.d('CreateClubDisclaimer'))
                    ])
                  ]),
                  controller.introImage() || controller.introVimeoVideoId() ?
                    m('div', { class: 'play-together-front-page-header-column-wrapper mobile-hide' }, [
                      controller.introVimeoVideoId() ? controller.video(controller.introVimeoVideoId()) :
                        m('img', {
                          class: 'column-image',
                          src: controller.introImage().Source,
                          alt: controller.introImage().AlternateText
                        })
                    ])
                    : null
                ]),
                m(PromotionSpots, { controller })
              ])
            ])
          ];
        }
      };

      // Routes:
      route('/', root);
    });

  });
